module.exports = __webpack_public_path__ + "a337ffcfce551e4a0fa73acf3a8a4619.svg";